import {Select, MenuItem, FormHelperText, FormControl, Box, Typography} from "@mui/material";
import React from "react";
import countries from "../../utils/countries";


const CountrySelect = (props) => {

    return (
        <FormControl fullWidth >
            <Select
                {...props}
                displayEmpty
                renderValue={(selected) => {
                    if (!selected) {
                        return <Typography color="textSecondary">{props.label}</Typography>;
                    }
                    const selectedCountry = countries.find((country) => country?.code === selected);
                    return (
                        <Box display="flex" alignItems="center">
                            <Box
                                component="img"
                                src={`https://flagcdn.com/w40/${selectedCountry?.code.toLowerCase()}.png`}
                                alt="flag"
                                sx={{marginRight: 1, width: 20, height: 15}}
                            />
                            {selectedCountry?.label}
                        </Box>
                    );
                }}
            >
                <MenuItem value="" disabled>
                    {props.label}
                </MenuItem>
                {countries.map((country) => (
                    <MenuItem key={country?.code} value={country?.code}>
                        <Box display="flex" alignItems="center">
                            <Box
                                component="img"
                                src={`https://flagcdn.com/w40/${country?.code.toLowerCase()}.png`}
                                alt="flag"
                                sx={{marginRight: 1, width: 20, height: 15}}
                            />
                            {country?.label}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
            {props.errors[props.name] && <FormHelperText>{props.errors[props.name]}</FormHelperText>}
        </FormControl>
    );
};

export default CountrySelect;
